import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { NUMBER_PROPERTY_MAX_VALUE_OPTIONS, NumberPropertyOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";
import { showsNumberPropertyMaxValue } from "./AdvancedSettings.ts";

/**
 * The two number-property dials (ADR 0032 §2).
 *
 * The operator bar is hidden for this format: a factor question has operands
 * but no operator to pick, and the question type already says what the sheet
 * asks.
 */
export function NumberPropertySettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: NumberPropertyOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, NumberPropertyQuestion: value });
    }

    function handleMaxValueChange(event) {
        setSettings({ ...settings, NumberPropertyMaxValue: Number(event.target.value) });
    }

    return (
        <div className="numberPropertySettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.NumberPropertyQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(NumberPropertyOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
            {showsNumberPropertyMaxValue(settings) && (
                <>
                <div className="selectContainer">
                    <span className="settingLabel">{t('settings.largestNumberLabel')}</span>
                </div>
                <div className="radioButtons" role="radiogroup" aria-label={t('settings.largestNumberAria')}>
                    {NUMBER_PROPERTY_MAX_VALUE_OPTIONS.map((option) => (
                        <div key={option}>
                            <RadioButton
                                inputId={`numberPropertyMaxValue-${option}`}
                                value={option}
                                checked={settings.NumberPropertyMaxValue === option}
                                onChange={handleMaxValueChange}
                            />
                            <label htmlFor={`numberPropertyMaxValue-${option}`}>{option}</label>
                        </div>
                    ))}
                </div>
                </>
            )}
        </div>
    );
}

export default NumberPropertySettings;
